<template>
  <ValidationProvider :name="name" :vid="id" :rules="rules" v-slot="{ failedRules }" slim>
    <label class="checkbox-field" :for="id">
      <slot name="label"><span v-html="label"></span></slot>
      <input
        role="checkbox"
        :aria-label="name"
        :id="id"
        :name="name"
        :tabindex="tabindex"
        class="checkbox-field__checkbox"
        v-model="innerChecked"
        type="checkbox"
        @change="emitInnerChecked(innerChecked)"
      />
      <span
        :class="[
          fillPurple
            ? 'checkbox-field__checkmark checkbox-field__checkmark-purple'
            : 'checkbox-field__checkmark',
          failedRules.checked ? 'border-danger' : ''
        ]"
      >
      </span>
    </label>
    <div class="checkbox-field__error -mt-1 ml-2_5">
      <div v-if="failedRules.checked && id === 'privacy-policy'">
        {{ translate('rwYouMustAgreePrivacyPolicy') }}
      </div>
      <div v-if="failedRules.checked && id === 'checkboxPIPL'">
        {{ translate('boCheckboxPIPLError') }}
      </div>
      <div v-else-if="failedRules.checked">{{ translate('rwThisIsRequired') }}</div>
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'Checkbox',
  components: {
    ValidationProvider
  },
  props: {
    id: {
      type: String
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: ''
    },
    tabindex: {
      type: String,
      default: '0'
    },
    fillPurple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerChecked: false
    }
  },
  watch: {
    checked(newValue) {
      this.innerChecked = newValue
    }
  },
  mounted() {
    this.innerChecked = this.checked
  },
  methods: {
    emitInnerChecked(newValue) {
      this.$emit('changed', newValue)
    }
  }
}
</script>

<style lang="scss" scoped>
$color-grey: #c2c3c5;

.-mt-1 {
  margin-top: -1rem;
}

.ml-2_5 {
  margin-left: 2.5rem;
}

.checkbox-field {
  display: inline-flex;
  align-items: flex-start;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 1.2rem;
  position: relative;
  padding: 1rem 0;
  padding-inline-start: 2.5rem;

  &__checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 8px;
    width: 8px;
    left: 0;
  }

  &__checkmark {
    position: absolute;
    left: 0;
    height: 2rem;
    width: 2rem;
    border: solid 1px $color-grey;
    border-radius: 0.4rem;
    background-color: white;
  }

  &__checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }
  &__error {
    color: crimson;
    font-size: 1.1rem;
  }
}

.filed:hover .checkbox-field__checkbox ~ .checkbox-field__checkmark {
  transition: background 100ms ease-in;
}

.checkbox-field .checkbox-field__checkbox:checked ~ .checkbox-field__checkmark {
  background-color: #c20808;
  transition: background 200ms ease-in;
}

.checkbox-field .checkbox-field__checkbox:checked ~ .checkbox-field__checkmark-purple {
  background-color: color('purple');
  transition: background 200ms ease-in;
}

.checkbox-field .checkbox-field__checkbox:checked ~ .checkbox-field__checkmark:after {
  display: block;
}

.checkbox-field .checkbox-field__checkmark:after {
  left: 6px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.empty {
  .checkbox-field {
    padding: 0;
  }
}

.disabled {
  .checkbox-field__checkmark {
    background-color: color('grey-soft-two');
  }
}
html[dir='rtl'] {
  .checkbox-field__checkbox,
  .checkbox-field__checkmark {
    right: 0;
  }
  .checkbox-field .checkbox-field__checkmark:after {
    left: 8px;
  }
}
html[lang='he-IL'] {
  .checkbox-field .checkbox-field__checkmark:after {
    left: 9px;
    top: 5px;
  }
}
</style>
